import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from './routers'
import lsProxy from '../utils/lsUtil'
Vue.use(VueRouter)

const RouterConfig = {
    mode: 'history',
    routes: routers
}

const router = new VueRouter(RouterConfig)

/**
 * 路由守卫
 */
router.beforeEach((to, from, next) => {
    let access = lsProxy.access
    if (access && to.name === 'login') { // 判断是否已经登录且前往的是登录页
        if (access) {
            next({
                name: 'home'
            });

        }else {
            next();
        }
    } else if (access && to.name === 'home') {
        next();
    }else if (!access && to.name !== 'login') {
        next({
            name: 'login'
        });
    } else {
        next();
    }
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js